/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITrimesterObservation } from 'app/shared/model/trimester-observation.model';
import { ISpecialityVitals } from 'app/shared/model/speciality-vitals.model';

export interface ITrimesterObservationParam {
  id?: string;
  observation?: string | null;
  comments?: string | null;
  draft?: boolean;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  trimester?: ITrimesterObservation | null;
  vital?: ISpecialityVitals | null;
}

export const defaultValue: Readonly<ITrimesterObservationParam> = {
  draft: false,
  active: false,
};
